import React from 'react';
import Button from '../components/Button';

type TblCreateEntityButtonProps = {
    onClick: () => void;
    id?: string;
};

const TableCreateEntityButton = ({ onClick, id }: TblCreateEntityButtonProps): JSX.Element => {
    return (
        <Button
            onClick={onClick}
            id={id}
        >
            Create
        </Button>
    );
};

export default TableCreateEntityButton;
